export interface Country {
    name: string;
    bbox: [number, number, number, number]; // [west, south, east, north]
}

export const countries: Country[] = [
    { name: "Afghanistan", bbox: [60.5, 29.4, 75.0, 38.5] },
    { name: "Albania", bbox: [19.3, 39.6, 21.1, 42.7] },
    { name: "Algeria", bbox: [-8.7, 19.0, 12.0, 37.1] },
    { name: "Andorra", bbox: [1.4, 42.4, 1.8, 42.7] },
    { name: "Angola", bbox: [11.7, -18.0, 24.1, -4.4] },
    { name: "Antigua and Barbuda", bbox: [-62.0, 16.9, -61.7, 17.7] },
    { name: "Argentina", bbox: [-73.6, -55.1, -53.6, -21.8] },
    { name: "Armenia", bbox: [43.4, 38.8, 46.6, 41.3] },
    { name: "Australia", bbox: [113.3, -44.0, 153.6, -10.7] },
    { name: "Austria", bbox: [9.5, 46.4, 17.2, 49.0] },
    { name: "Azerbaijan", bbox: [44.8, 38.4, 50.4, 41.9] },
    { name: "Bahamas", bbox: [-78.3, 22.0, -72.7, 27.3] },
    { name: "Bahrain", bbox: [50.4, 25.8, 50.7, 26.3] },
    { name: "Bangladesh", bbox: [88.0, 20.7, 92.7, 26.6] },
    { name: "Barbados", bbox: [-59.7, 13.0, -59.4, 13.3] },
    { name: "Belarus", bbox: [23.2, 51.3, 32.8, 56.2] },
    { name: "Belgium", bbox: [2.5, 49.5, 6.4, 51.5] },
    { name: "Belize", bbox: [-89.2, 15.9, -87.8, 18.5] },
    { name: "Benin", bbox: [0.8, 6.2, 3.9, 12.4] },
    { name: "Bhutan", bbox: [88.8, 26.7, 92.1, 28.3] },
    { name: "Bolivia", bbox: [-69.6, -22.9, -57.5, -9.7] },
    { name: "Bosnia and Herzegovina", bbox: [15.7, 42.6, 19.6, 45.3] },
    { name: "Botswana", bbox: [20.0, -26.9, 29.4, -17.8] },
    { name: "Brazil", bbox: [-73.9, -33.8, -34.8, 5.3] },
    { name: "Brunei", bbox: [114.0, 4.0, 115.4, 5.1] },
    { name: "Bulgaria", bbox: [22.4, 41.2, 28.6, 44.2] },
    { name: "Burkina Faso", bbox: [-5.5, 9.4, 2.4, 15.1] },
    { name: "Burundi", bbox: [29.0, -4.5, 30.8, -2.3] },
    { name: "Cabo Verde", bbox: [-25.4, 14.8, -22.7, 17.2] },
    { name: "Cambodia", bbox: [102.3, 10.4, 107.6, 14.7] },
    { name: "Cameroon", bbox: [8.5, 1.7, 16.2, 13.1] },
    { name: "Canada", bbox: [-141.0, 41.7, -52.6, 83.1] },
    { name: "Central African Republic", bbox: [14.4, 2.2, 27.5, 11.0] },
    { name: "Chad", bbox: [13.5, 7.4, 24.0, 23.5] },
    { name: "Chile", bbox: [-75.6, -55.6, -66.4, -17.5] },
    { name: "China", bbox: [73.7, 18.2, 135.1, 53.6] },
    { name: "Colombia", bbox: [-79.0, -4.2, -66.9, 12.5] },
    { name: "Comoros", bbox: [43.2, -12.4, 44.5, -11.4] },
    { name: "Congo", bbox: [11.2, -5.0, 18.6, 3.7] },
    { name: "Costa Rica", bbox: [-85.9, 8.0, -82.6, 11.2] },
    { name: "Cote d'Ivoire", bbox: [-8.6, 4.4, -2.5, 10.7] },
    { name: "Croatia", bbox: [13.5, 42.4, 19.4, 46.5] },
    { name: "Cuba", bbox: [-84.9, 19.8, -74.1, 23.3] },
    { name: "Cyprus", bbox: [32.3, 34.6, 34.6, 35.7] },
    { name: "Czech Republic", bbox: [12.1, 48.6, 18.9, 51.1] },
    { name: "Democratic Republic of the Congo", bbox: [12.2, -13.5, 31.3, 5.4] },
    { name: "Denmark", bbox: [8.1, 54.6, 12.7, 57.7] },
    { name: "Djibouti", bbox: [41.8, 10.9, 43.4, 12.7] },
    { name: "Dominica", bbox: [-61.5, 15.2, -61.2, 15.6] },
    { name: "Dominican Republic", bbox: [-72.0, 17.6, -68.3, 19.9] },
    { name: "Ecuador", bbox: [-80.9, -4.9, -75.2, 1.4] },
    { name: "Egypt", bbox: [24.7, 22.0, 36.9, 31.7] },
    { name: "El Salvador", bbox: [-90.1, 13.1, -87.7, 14.4] },
    { name: "Equatorial Guinea", bbox: [9.3, 0.9, 11.3, 2.3] },
    { name: "Eritrea", bbox: [36.4, 12.4, 43.1, 18.0] },
    { name: "Estonia", bbox: [21.8, 57.5, 28.2, 59.7] },
    { name: "Eswatini", bbox: [30.8, -27.3, 32.1, -25.7] },
    { name: "Ethiopia", bbox: [33.0, 3.4, 48.0, 14.9] },
    { name: "Fiji", bbox: [177.0, -20.7, -178.1, -16.0] },
    { name: "Finland", bbox: [20.5, 59.8, 31.6, 70.1] },
    { name: "France", bbox: [-5.1, 41.3, 9.6, 51.1] },
    { name: "Gabon", bbox: [8.7, -4.0, 14.5, 2.3] },
    { name: "Gambia", bbox: [-16.8, 13.1, -13.8, 13.8] },
    { name: "Georgia", bbox: [40.0, 41.1, 46.7, 43.6] },
    { name: "Germany", bbox: [5.9, 47.3, 15.0, 55.1] },
    { name: "Ghana", bbox: [-3.3, 4.7, 1.2, 11.2] },
    { name: "Greece", bbox: [19.4, 34.8, 28.2, 41.7] },
    { name: "Grenada", bbox: [-61.8, 12.0, -61.4, 12.5] },
    { name: "Guatemala", bbox: [-92.2, 13.7, -88.2, 17.8] },
    { name: "Guinea", bbox: [-15.1, 7.2, -7.7, 12.7] },
    { name: "Guinea-Bissau", bbox: [-16.7, 11.0, -13.6, 12.7] },
    { name: "Guyana", bbox: [-61.4, 1.2, -56.5, 8.6] },
    { name: "Haiti", bbox: [-74.5, 18.0, -71.6, 20.1] },
    { name: "Honduras", bbox: [-89.4, 12.9, -83.1, 16.5] },
    { name: "Hungary", bbox: [16.1, 45.7, 22.9, 48.6] },
    { name: "Iceland", bbox: [-24.5, 63.4, -13.5, 66.5] },
    { name: "India", bbox: [68.2, 6.8, 97.4, 35.5] },
    { name: "Indonesia", bbox: [95.0, -11.0, 141.0, 6.1] },
    { name: "Iran", bbox: [44.0, 25.1, 63.3, 39.8] },
    { name: "Iraq", bbox: [38.8, 29.1, 48.6, 37.4] },
    { name: "Ireland", bbox: [-10.5, 51.4, -6.0, 55.4] },
    { name: "Israel", bbox: [34.3, 29.5, 35.9, 33.3] },
    { name: "Italy", bbox: [6.6, 35.5, 18.5, 47.1] },
    { name: "Jamaica", bbox: [-78.4, 17.7, -76.2, 18.5] },
    { name: "Japan", bbox: [129.4, 31.0, 145.8, 45.5] },
    { name: "Jordan", bbox: [34.9, 29.2, 39.3, 33.4] },
    { name: "Kazakhstan", bbox: [46.5, 40.9, 87.3, 55.4] },
    { name: "Kenya", bbox: [33.9, -4.7, 41.9, 5.5] },
    { name: "Kiribati", bbox: [-174.5, -11.4, 150.2, 4.7] },
    { name: "Korea, North", bbox: [124.3, 37.7, 130.7, 43.0] },
    { name: "Korea, South", bbox: [125.9, 33.2, 129.6, 38.6] },
    { name: "Kosovo", bbox: [20.0, 41.9, 21.8, 43.3] },
    { name: "Kuwait", bbox: [46.6, 28.5, 48.4, 30.1] },
    { name: "Kyrgyzstan", bbox: [69.3, 39.2, 80.3, 43.2] },
    { name: "Laos", bbox: [100.1, 13.9, 107.7, 22.5] },
    { name: "Latvia", bbox: [21.0, 55.7, 28.2, 58.1] },
    { name: "Lebanon", bbox: [35.1, 33.1, 36.6, 34.7] },
    { name: "Lesotho", bbox: [27.0, -30.7, 29.5, -28.6] },
    { name: "Liberia", bbox: [-11.5, 4.4, -7.4, 8.6] },
    { name: "Libya", bbox: [9.3, 20.1, 25.2, 33.2] },
    { name: "Liechtenstein", bbox: [9.5, 47.0, 9.6, 47.3] },
    { name: "Lithuania", bbox: [21.0, 53.9, 26.8, 56.4] },
    { name: "Luxembourg", bbox: [5.7, 49.4, 6.5, 50.2] },
    { name: "Madagascar", bbox: [43.2, -25.6, 50.5, -11.9] },
    { name: "Malawi", bbox: [32.7, -17.1, 35.9, -9.4] },
    { name: "Malaysia", bbox: [99.6, 0.9, 119.3, 7.4] },
    { name: "Maldives", bbox: [72.7, -0.7, 73.8, 7.1] },
    { name: "Mali", bbox: [-12.2, 10.1, 4.3, 25.0] },
    { name: "Malta", bbox: [14.2, 35.8, 14.6, 36.1] },
    { name: "Marshall Islands", bbox: [165.2, 5.6, 171.9, 14.8] },
    { name: "Mauritania", bbox: [-17.1, 14.7, -4.8, 27.3] },
    { name: "Mauritius", bbox: [57.3, -20.5, 63.5, -19.7] },
    { name: "Mexico", bbox: [-117.1, 14.5, -86.7, 32.7] },
    { name: "Micronesia", bbox: [137.4, 1.0, 163.0, 10.1] },
    { name: "Moldova", bbox: [26.6, 45.5, 30.1, 48.5] },
    { name: "Monaco", bbox: [7.4, 43.7, 7.4, 43.8] },
    { name: "Mongolia", bbox: [87.7, 41.6, 119.9, 52.1] },
    { name: "Montenegro", bbox: [18.4, 41.9, 20.4, 43.5] },
    { name: "Morocco", bbox: [-13.2, 27.7, -1.0, 35.9] },
    { name: "Mozambique", bbox: [30.2, -26.9, 40.8, -10.5] },
    { name: "Myanmar", bbox: [92.2, 9.8, 101.2, 28.5] },
    { name: "Namibia", bbox: [11.7, -29.0, 25.3, -16.9] },
    { name: "Nauru", bbox: [166.9, -0.6, 166.9, -0.5] },
    { name: "Nepal", bbox: [80.1, 26.4, 88.2, 30.4] },
    { name: "Netherlands", bbox: [3.4, 50.8, 7.2, 53.6] },
    { name: "New Zealand", bbox: [166.5, -47.3, 178.6, -34.4] },
    { name: "Nicaragua", bbox: [-87.7, 10.7, -82.7, 15.0] },
    { name: "Niger", bbox: [0.2, 11.7, 16.0, 23.5] },
    { name: "Nigeria", bbox: [2.7, 4.3, 14.7, 13.9] },
    { name: "North Macedonia", bbox: [20.5, 40.9, 23.0, 42.4] },
    { name: "Norway", bbox: [4.6, 58.0, 31.3, 80.8] },
    { name: "Oman", bbox: [51.9, 16.6, 59.8, 26.4] },
    { name: "Pakistan", bbox: [60.9, 23.7, 77.8, 37.1] },
    { name: "Palau", bbox: [131.1, 2.9, 134.7, 8.1] },
    { name: "Palestine", bbox: [34.2, 31.2, 35.6, 32.5] },
    { name: "Panama", bbox: [-83.0, 7.2, -77.2, 9.6] },
    { name: "Papua New Guinea", bbox: [140.8, -11.7, 159.0, -0.9] },
    { name: "Paraguay", bbox: [-62.6, -27.6, -54.3, -19.3] },
    { name: "Peru", bbox: [-81.3, -18.3, -68.7, -0.0] },
    { name: "Philippines", bbox: [116.9, 4.6, 126.6, 21.1] },
    { name: "Poland", bbox: [14.1, 49.0, 24.1, 54.8] },
    { name: "Portugal", bbox: [-9.5, 36.8, -6.2, 42.2] },
    { name: "Qatar", bbox: [50.8, 24.5, 51.6, 26.2] },
    { name: "Romania", bbox: [20.3, 43.6, 29.7, 48.3] },
    { name: "Russia", bbox: [-180.0, 41.2, 180.0, 81.9] },
    { name: "Rwanda", bbox: [28.9, -2.8, 30.9, -1.0] },
    { name: "Saint Kitts and Nevis", bbox: [-62.9, 17.1, -62.5, 17.4] },
    { name: "Saint Lucia", bbox: [-61.1, 13.7, -60.9, 14.1] },
    { name: "Saint Vincent and the Grenadines", bbox: [-61.5, 12.6, -61.1, 13.4] },
    { name: "Samoa", bbox: [-172.8, -14.1, -171.4, -13.4] },
    { name: "San Marino", bbox: [12.4, 43.9, 12.5, 44.0] },
    { name: "Sao Tome and Principe", bbox: [6.5, 0.0, 7.5, 1.7] },
    { name: "Saudi Arabia", bbox: [34.5, 16.4, 55.7, 32.2] },
    { name: "Senegal", bbox: [-17.5, 12.3, -11.3, 16.7] },
    { name: "Serbia", bbox: [18.8, 42.2, 23.0, 46.2] },
    { name: "Seychelles", bbox: [46.2, -9.8, 56.3, -4.3] },
    { name: "Sierra Leone", bbox: [-13.3, 6.9, -10.3, 10.0] },
    { name: "Singapore", bbox: [103.6, 1.2, 104.0, 1.5] },
    { name: "Slovakia", bbox: [16.8, 47.7, 22.6, 49.6] },
    { name: "Slovenia", bbox: [13.4, 45.4, 16.6, 46.9] },
    { name: "Solomon Islands", bbox: [155.5, -11.9, 167.0, -6.6] },
    { name: "Somalia", bbox: [40.9, -1.7, 51.4, 12.0] },
    { name: "South Africa", bbox: [16.5, -34.8, 32.9, -22.1] },
    { name: "South Sudan", bbox: [23.9, 3.5, 35.9, 12.2] },
    { name: "Spain", bbox: [-9.3, 35.2, 4.3, 43.8] },
    { name: "Sri Lanka", bbox: [79.7, 5.9, 81.9, 9.8] },
    { name: "Sudan", bbox: [21.8, 8.7, 38.6, 22.2] },
    { name: "Suriname", bbox: [-58.1, 1.8, -53.9, 6.0] },
    { name: "Sweden", bbox: [11.1, 55.3, 24.2, 69.1] },
    { name: "Switzerland", bbox: [6.0, 45.8, 10.5, 47.8] },
    { name: "Syria", bbox: [35.7, 32.3, 42.4, 37.3] },
    { name: "Taiwan", bbox: [120.1, 21.9, 122.0, 25.3] },
    { name: "Tajikistan", bbox: [67.4, 36.7, 75.1, 41.0] },
    { name: "Tanzania", bbox: [29.3, -11.7, 40.4, -0.9] },
    { name: "Thailand", bbox: [97.3, 5.6, 105.6, 20.5] },
    { name: "Timor-Leste", bbox: [124.0, -9.5, 127.3, -8.1] },
    { name: "Togo", bbox: [-0.1, 6.1, 1.8, 11.1] },
    { name: "Tonga", bbox: [-175.7, -21.5, -173.9, -15.6] },
    { name: "Trinidad and Tobago", bbox: [-61.9, 10.0, -60.5, 11.3] },
    { name: "Tunisia", bbox: [7.5, 30.2, 11.6, 37.5] },
    { name: "Turkey", bbox: [26.0, 35.8, 44.8, 42.1] },
    { name: "Turkmenistan", bbox: [52.4, 35.1, 66.7, 42.8] },
    { name: "Tuvalu", bbox: [176.1, -10.8, 179.9, -5.6] },
    { name: "Uganda", bbox: [29.6, -1.5, 35.0, 4.2] },
    { name: "Ukraine", bbox: [22.1, 44.4, 40.2, 52.4] },
    { name: "United Arab Emirates", bbox: [51.6, 22.6, 56.4, 26.1] },
    { name: "United Kingdom", bbox: [-8.6, 49.9, 1.8, 60.8] },
    { name: "United States", bbox: [-180.0, 18.9, -66.9, 71.4] },
    { name: "Uruguay", bbox: [-58.4, -35.0, -53.1, -30.1] },
    { name: "Uzbekistan", bbox: [55.9, 37.2, 73.1, 45.6] },
    { name: "Vanuatu", bbox: [166.5, -20.2, 170.2, -13.1] },
    { name: "Vatican City", bbox: [12.4, 41.9, 12.5, 41.9] },
    { name: "Venezuela", bbox: [-73.4, 0.6, -59.8, 12.2] },
    { name: "Vietnam", bbox: [102.1, 8.6, 109.5, 23.4] },
    { name: "Yemen", bbox: [42.6, 12.1, 53.1, 19.0] },
    { name: "Zambia", bbox: [22.0, -18.1, 33.7, -8.2] },
    { name: "Zimbabwe", bbox: [25.2, -22.4, 33.1, -15.6] }
];

// Export just the country names for backward compatibility
export const countryNames = countries.map(c => c.name);